import React, { useMemo, useContext } from 'react';
import query from '../Queries/AttestantIDQuery.gql';
import { IStandardRutinWrapperProps } from '../../../../_StandardRutin/StandardRutin';
import { useQuery } from '@apollo/client';
import { ActiveDatabaseContext } from '../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { AttestantIDQuery } from '../Queries/_QueryTypes/AttestantIDQuery';
import FakturaattestProviderWrapper from './FakturattestProviderWrapper';
import EDAvenyProgress from '../../../../../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';

const FakturaattestWrapper: React.FC<
  React.PropsWithChildren<IStandardRutinWrapperProps>
> = props => {
  const { activeDatabase } = useContext(ActiveDatabaseContext);

  const { data, loading } = useQuery<AttestantIDQuery>(query, {
    variables: { dbname: activeDatabase ?? '' },
    skip: !activeDatabase,
  });

  const ID = useMemo(() => data?.me?.[0]?.attestantID ?? '', [data?.me]);

  if (loading) {
    return <EDAvenyProgress />;
  }

  return (
    <FakturaattestProviderWrapper attestantID={ID}>
      {props.children}
    </FakturaattestProviderWrapper>
  );
};

export default FakturaattestWrapper;
